import moment from "moment";

export default {
  formatDate(date) {
    return moment(date).format("YYYY-MM-DD");
  },
  formatDateTime(dateTime) {
    return moment(dateTime).format("YYYY-MM-DD HH:mm");
  },
  formatTime(time) {
    return moment(time, "HH:mm:ss").format("LT");
  },
  formatGoogleTime(dateTime) {
    const now = moment();
    const momentDateTime = moment(dateTime);
    const diffHours = now.diff(momentDateTime, "hours");
    const diffYears = now.diff(momentDateTime, "years");
    if (diffHours < 0) {
      if(diffYears > -1 && diffYears < 1){
        return moment(dateTime).format("MM/DD");
      } else {
        return moment(dateTime).format("YYYY/MM/DD");
      }
    } else if (diffHours < 24) {
      return moment(dateTime).format("HH:mm");
    }
    const todayDate = now.format("MM/DD");
    const momentDate = momentDateTime.format("MM/DD");
    console.log(todayDate);
    console.log(momentDate);
    if (diffYears > -1 && diffYears < 1 && todayDate !== momentDate) {
      return moment(dateTime).format("MM/DD");
    }
    return moment(dateTime).format("YYYY/M/DD");
  },
  formatSecondToMMSS(seconds) {
    return `${String(Math.floor(seconds / 60)).padStart(2, "0")}:${String(
      seconds % 60
    ).padStart(2, "0")}`;
  }
};
